import React from 'react';
import HousingLogo from 'assets/img/test-housing-Logo.svg';
import {Container, HeaderTitle, HeaderWrapper, LogoContainer, Title} from '../styled';

type NavBarProps = {
  title: string;
  logo?: string;
};

function Navbar({title, logo}: NavBarProps) {
  return (
    <HeaderWrapper visible className="navbar">
      <Container>
        <LogoContainer className="navbar__logo">
          <img
            src={logo ? logo : HousingLogo}
            alt="housing Logo"
            className="navbar__logo-img"
          />
        </LogoContainer>
        <HeaderTitle className="navbar__title">
          <Title className="navbar__title-text">{title}</Title>
        </HeaderTitle>
      </Container>
    </HeaderWrapper>
  );
}

export {Navbar};
